import React from 'react';

const PageHeader = ({ title, subtitle, actions }) => (
    <div className="hp-page-head">
        <div>
            <h1 className="hp-page-title">{title}</h1>
            {subtitle && <p className="hp-page-sub">{subtitle}</p>}
        </div>
        {actions && <div className="d-flex flex-wrap gap-2">{actions}</div>}
    </div>
);

export default PageHeader;
